import { render, staticRenderFns } from "./NewsEditTabInformation.vue?vue&type=template&id=16f0b698&"
import script from "./NewsEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./NewsEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./NewsEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports